export const convertString = (string) => {
    return string.slice(0, 5)
}
export const Nzero = n =>{
    return n>9?n: '0'+n
}